import { render, staticRenderFns } from "./skpp.vue?vue&type=template&id=a974e8ba&"
import script from "./skpp.vue?vue&type=script&lang=js&"
export * from "./skpp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports